module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('签证邀请信息')))]), _vm._v(" "), _c('div', {
    staticClass: "visa-reference-tips"
  }, [_c('p', {
    staticClass: "visa-reference-tips__title"
  }, [_vm._v(_vm._s(_vm.$T('签证政策参考')))]), _vm._v(" "), _c('ul', {
    staticClass: "visa-reference-tips__list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.visaRefLinks.mutualExemption,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$T('签证参考互免协定一览')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.visaRefLinks.unilateralFaq,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$T('签证参考单方面免签')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.openVisaDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$T('添加签证')))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.visaList,
      "border": "",
      "stripe": "",
      "size": "mini",
      "empty-text": _vm.$T('暂无数据')
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$T('姓'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.nameSurname(scope.row.name)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('名'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.nameGiven(scope.row.name)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('性别'),
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.sexLabel(scope.row.sex)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "passport_number",
      "label": _vm.$T('护照号码'),
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pass_expiry_date",
      "label": _vm.$T('护照到期日'),
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city_to_apply",
      "label": _vm.$T('申请城市'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "arrival_date",
      "label": _vm.$T('抵达日期'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "departure_date",
      "label": _vm.$T('离境日期'),
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('照片'),
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.fileCount(scope.row.photo) > 0 ? _vm.$T('已上传') : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('护照PDF'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.fileCount(scope.row.pass_pdf) > 0 ? _vm.$T('已上传') : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('操作'),
      "width": "140",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openVisaDialog(scope.row, scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('编辑')))]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeVisa(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('删除')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onNext
    }
  }, [_vm._v(_vm._s(_vm.$T('下一步')))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editingIndex > -1 ? _vm.$T('编辑签证邀请') : _vm.$T('新增签证邀请'),
      "visible": _vm.showDialog,
      "width": "720px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      },
      "closed": _vm.onDialogClosed
    }
  }, [_c('el-form', {
    ref: "visaFormRef",
    staticClass: "visa-dialog-form",
    attrs: {
      "model": _vm.visaForm,
      "rules": _vm.visaRules,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('姓'),
      "prop": "surname"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": _vm.$T('请输入姓')
    },
    model: {
      value: (_vm.visaForm.surname),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "surname", $$v)
      },
      expression: "visaForm.surname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('名'),
      "prop": "given_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": _vm.$T('请输入名')
    },
    model: {
      value: (_vm.visaForm.given_name),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "given_name", $$v)
      },
      expression: "visaForm.given_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('出生日期'),
      "prop": "birthday"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.visaForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "birthday", $$v)
      },
      expression: "visaForm.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('性别'),
      "prop": "sex"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.visaForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "sex", $$v)
      },
      expression: "visaForm.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$T('男')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$T('女')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('护照号码'),
      "prop": "passport_number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": _vm.$T('请输入护照号码')
    },
    model: {
      value: (_vm.visaForm.passport_number),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "passport_number", $$v)
      },
      expression: "visaForm.passport_number"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('护照到期日'),
      "prop": "pass_expiry_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.visaForm.pass_expiry_date),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "pass_expiry_date", $$v)
      },
      expression: "visaForm.pass_expiry_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('申请城市'),
      "prop": "city_to_apply"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": _vm.$T('请输入申请城市')
    },
    model: {
      value: (_vm.visaForm.city_to_apply),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "city_to_apply", $$v)
      },
      expression: "visaForm.city_to_apply"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('抵达日期'),
      "prop": "arrival_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.visaForm.arrival_date),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "arrival_date", $$v)
      },
      expression: "visaForm.arrival_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('离境日期'),
      "prop": "departure_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.visaForm.departure_date),
      callback: function($$v) {
        _vm.$set(_vm.visaForm, "departure_date", $$v)
      },
      expression: "visaForm.departure_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$T('照片')
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.visaForm.photo,
      "limit": 3
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$T('护照PDF')
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.visaForm.pass_pdf,
      "limit": 3,
      "accept": ".pdf"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$T('取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmVisa
    }
  }, [_vm._v(_vm._s(_vm.$T('确定')))])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d72e3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep6.vue
// module id = 1432
// module chunks = 0